import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import media from "../../styles/media"

export const CarouselArrowButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  position: absolute;
  z-index: 2;
  top: 50%;
  height: 40px;
  width: 25px;
  border-radius: 5px;
  transform: translateY(-50%);

  ${media.tablet`
    &:hover {
      .arrow-line {
        stroke: ${props => props.theme.red};
      }
    }
 `}

  ${props => {
    return props.direction === "left"
      ? css`
          left: -30px;

          ${media.tablet`
            left: -35px;
          `}
        `
      : css`
          right: -30px;

          ${media.tablet`
            right: -35px;
          `}
        `
  }}
`

const colors = {
  disabled: "#959595",
  enabled: "#000000",
}

// We're intentionally not spreading `props` here, since Slick adds all sorts of CSS that we want to
// entirely ignore to our arrows.
const CarouselArrow = ({ disabled, direction = "left", onClick, ...props }) => (
  <CarouselArrowButton onClick={onClick} direction={direction}>
    <svg
      width={18}
      height={19}
      // The exported SVG asset is a left facing arrow, so if we're rendering
      // a right arrow, we need to flip it
      style={{
        transform: direction === "right" ? "scaleX(-1)" : "",
      }}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-601.000000, -1845.000000)"
          stroke={disabled ? colors.disabled : colors.enabled}
          strokeWidth="1.33"
          className="arrow-line"
        >
          <g transform="translate(34.000000, 1402.000000)">
            <g transform="translate(575.500000, 452.500000) rotate(-270.000000) translate(-575.500000, -452.500000) translate(567.000000, 444.000000)">
              <polyline points="17 7.59807692 8.49933847 15.5980769 -5.09038573e-17 7.59807692" />
              <path d="M8.4995,15.7231538 L8.5005,-0.276846154" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </CarouselArrowButton>
)

CarouselArrow.propTypes = {
  disabled: PropTypes.bool,
  direction: PropTypes.oneOf(["left", "right"]),
  onClick: PropTypes.func,
}

export default CarouselArrow
